/**
 * Stats Strip - Top metrics bar for Lead Command Center
 */
import React from "react";
import { TrendingUp, Users, Zap, Clock, AlertTriangle, Target } from "lucide-react";

const StatCard = ({ label, value, subValue, icon: Icon, color = "text-white" }) => (
  <div className="flex items-center gap-3 px-4 py-3 bg-slate-900/50 rounded-lg border border-slate-800">
    <div className={`p-2 rounded-lg bg-slate-800 ${color}`}>
      <Icon className="h-4 w-4" />
    </div>
    <div>
      <p className="text-xs text-slate-500 uppercase tracking-wider">{label}</p>
      <p className={`text-xl font-bold ${color}`}>{value}</p>
      {subValue && <p className="text-xs text-slate-500">{subValue}</p>}
    </div>
  </div>
);

const StatsStrip = ({ stats }) => {
  if (!stats) return null;

  const formatCurrency = (value) => {
    if (!value) return "$0";
    if (value >= 1000000) return `$${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `$${(value / 1000).toFixed(0)}K`;
    return `$${value.toFixed(0)}`;
  };

  return (
    <div className="border-b border-slate-800 bg-slate-900/30">
      <div className="max-w-[1800px] mx-auto px-6 py-4">
        <div className="grid grid-cols-6 gap-4">
          <StatCard
            label="Active Leads"
            value={stats.active || 0}
            subValue={`${stats.today || 0} today`}
            icon={Users}
            color="text-blue-400"
          />
          <StatCard
            label="Response Rate"
            value={`${stats.response_rate || 0}%`}
            subValue={`${stats.avg_response_time_seconds || 0}s avg`}
            icon={Zap}
            color="text-emerald-400"
          />
          <StatCard
            label="Stagnant"
            value={stats.stagnant || 0}
            subValue="Need attention"
            icon={AlertTriangle}
            color={stats.stagnant > 0 ? "text-amber-400" : "text-slate-400"}
          />
          <StatCard
            label="Close Rate"
            value={`${stats.close_rate || 0}%`}
            subValue="Win ratio"
            icon={Target}
            color="text-purple-400"
          />
          <StatCard
            label="Pipeline Value"
            value={formatCurrency(stats.value?.pipeline_total)}
            subValue="Active opportunities"
            icon={TrendingUp}
            color="text-cyan-400"
          />
          <StatCard
            label="Won This Month"
            value={formatCurrency(stats.value?.won_this_month)}
            subValue={formatCurrency(stats.value?.won_total) + " total"}
            icon={TrendingUp}
            color="text-emerald-400"
          />
        </div>
      </div>
    </div>
  );
};

export default StatsStrip;
